import styles from "./GlobalInput.module.css";

const GlobalInput = ({
  title,
  placeholder = "Placeholder",
  type = "text",
  name,
  size = "large",
  error = false,
  ...props
}) => {
  const sizeClasses = {
    large: styles["input--large"],
    small: styles["input--small"],
  };

  return (
    <>
      {title && (
        <label
          className={styles.label}
          style={{
            color: error ? "var(--error-color)" : "var(--heading-color)",
          }}
        >
          {title}
        </label>
      )}
      <input
        {...props}
        name={name}
        type={type}
        placeholder={placeholder}
        className={`${styles.input} ${sizeClasses[size] || ""}`}
      />
    </>
  );
};

export default GlobalInput;
